module.exports = __webpack_public_path__ + "static/media/reset.9bf9657d.svg";